import { render } from "./HomeComboard.vue?vue&type=template&id=310a6be4"
import script from "./HomeComboard.vue?vue&type=script&lang=js"
export * from "./HomeComboard.vue?vue&type=script&lang=js"

import "./HomeComboard.vue?vue&type=style&index=0&id=310a6be4&lang=css"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__